import React from "react";

import { useGetChildDevicesPagedLazyQuery, useGetChildDevicesPagedQuery } from "gql/generated/types";
import DevicesContent from "../components/Device/DevicesContent";

const ChildDevices = () => (
  <DevicesContent
    tableName="ChildDevices"
    useGetDevicesPagedLazyQuery={useGetChildDevicesPagedLazyQuery}
    useGetDevicesPagedQuery={useGetChildDevicesPagedQuery}
    dataKey="mdmChildDevicesByProjectIdPaged"
  />
);

export default ChildDevices;